import type { BatchHealthcheckResult } from '../api/proxies';

// Which server a result belongs to. Names are unique per node; the address
// covers a result whose name is missing.
const serverKey = (result: BatchHealthcheckResult): string =>
  result.node_name?.trim() || result.agent_ip?.trim() || `proxy-${result.proxy_id}`;

// How many distinct servers report each outbound IPv4. Proxies on the same
// server always share that server's exit IP, so only a different server
// with the same IP is a real duplicate.
export const countDetectedIPv4 = (
  results: BatchHealthcheckResult[],
): Map<string, number> => {
  const servers = new Map<string, Set<string>>();
  for (const result of results) {
    const ip = result.detected_ipv4?.trim();
    if (!result.ipv4_check_ok || !ip) continue;
    const seen = servers.get(ip) ?? new Set<string>();
    seen.add(serverKey(result));
    servers.set(ip, seen);
  }
  return new Map([...servers].map(([ip, set]) => [ip, set.size]));
};

export const duplicateIPv4GroupCount = (counts: ReadonlyMap<string, number>): number =>
  [...counts.values()].filter((count) => count > 1).length;
